import axios from "axios";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_BaseApi_URL_BlueSalt,
  timeout: 10000,
});

// //Add a request interceptor
// axios.interceptors.request.use(
//   function (config) {
//     const token = JSON.parse(sessionStorage.getItem("token"));
//     config.headers.Authorization = token;
//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

// //Add a response interceptor
// axios.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (error.status === 500) return Promise.reject(error);
//   }
// );

export default Axios;
